import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { toast } from "@/common/utils/toast";
import { useI18n } from "vue-i18n";
import { onBeforeMount, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getUser, removeUser } from "@/common/services/user";
import {
  userCheckToken,
  userProfile,
  userAccount,
  userAffiliateList,
} from "@/common/api/rest/user";
import store from "@/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const isMobile = ref(false);
const affiliate = ref<any[]>([]);

async function checkToken() {
  await userCheckToken()
    .then((response) => {
      const { success } = response;

      if (!success) removeUser();
    })
    .catch(() => {
      removeUser();
    });
}

async function fecthAccount() {
  const accountId = route.params.id as string;

  if (!accountId) return;

  await userAccount(accountId).then((response) => {
    const { code, success, data } = response;

    if (!success) {
      if (code === 401) removeUser();

      if (code === 403) {
        store.commit("SET_ACCOUNT", null);
        router.push("/accounts");
      }
      return;
    }

    const isOwner = data.member_id === store.getters.user?.member_id;

    // Prioridade: dono > afiliado > padrão
    let currentType = "TECHNICIAN";

    if (isOwner) {
      currentType = "ADMIN";
    } else {
      const aff = affiliate.value.find(
        (item: any) => item.account_id === accountId,
      );

      if (aff) {
        currentType = aff.type;
      }
    }

    store.commit("SET_ACCOUNT", {
      ...data,
      type: currentType,
    });

    store.commit("SET_MODULES", data.modules);

    store.commit("SET_TYPE", currentType);
  });
}

async function fecthAffiliate() {
  await userAffiliateList(store.getters.user?.member_id)
    .then((response) => {
      const { success, data, message } = response;
      if (success) {
        affiliate.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function fecthProfile() {
  await userProfile().then((response) => {
    const { success, code, data } = response;
    if (success) {
      store.commit("SET_PROFILE", data);
    } else if (code === 401) {
      removeUser();
    }
  });
}

onBeforeMount(async () => {
  const user = getUser();

  if (!user) {
    removeUser();
    return;
  }

  store.commit("SET_USER", user);

  await checkToken();
  await fecthProfile();
  await fecthAffiliate();
  await fecthAccount();

  store.commit("SET_LOGGED", true);

  // if (route.path === "/auth/login") {
  //   router.push("/accounts");
  // }
});

watch(
  () => isMobile.value,
  (value) => {
    store.commit("SET_MOBILE", value);
  },
);

onMounted(() => {
  isMobile.value = window.innerWidth < 1024;

  window.addEventListener("resize", () => {
    isMobile.value = window.innerWidth < 1024;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})